var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "contact",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 33.4,
    y1: 94.96,
    x2: 91.95,
    y2: 11.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ff80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#09ff83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#21ff8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#49ff97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64ffa0"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.54,121.62a8.31,8.31,0,0,1-3.3-3.11,9.08,9.08,0,0,1,0-9,8.31,8.31,0,0,1,3.3-3.11,10,10,0,0,1,4.74-1.12,10.21,10.21,0,0,1,4.15.82,8,8,0,0,1,3.07,2.35l-3,2.74a5,5,0,0,0-4-2,4.93,4.93,0,0,0-2.44.6,4.13,4.13,0,0,0-1.65,1.69,5.63,5.63,0,0,0,0,5,4.13,4.13,0,0,0,1.65,1.69,4.93,4.93,0,0,0,2.44.6,5,5,0,0,0,4-2l3,2.74a8,8,0,0,1-3.07,2.35,10.21,10.21,0,0,1-4.15.82A10,10,0,0,1,7.54,121.62Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.94,121.61a8.44,8.44,0,0,1-3.34-3.12,8.94,8.94,0,0,1,0-9,8.44,8.44,0,0,1,3.34-3.12,10.72,10.72,0,0,1,9.58,0,8.6,8.6,0,0,1,0,15.22,10.72,10.72,0,0,1-9.58,0ZM32,118.2a4.28,4.28,0,0,0,1.63-1.69,5.55,5.55,0,0,0,0-5A4.28,4.28,0,0,0,32,109.8a4.73,4.73,0,0,0-4.61,0,4.35,4.35,0,0,0-1.63,1.69,5.55,5.55,0,0,0,0,5,4.35,4.35,0,0,0,1.63,1.69,4.73,4.73,0,0,0,4.61,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.54,105.6v16.8H53.63l-7.41-9v9H41.56V105.6h3.91l7.42,9v-9Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.48,109.37H59.32V105.6H74.37v3.77H69.23v13H64.48Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.56,119.14h-7.1l-1.32,3.26H73.29l7.41-16.8h4.68l7.44,16.8H87.88Zm-1.39-3.51L83,110.26l-2.16,5.37Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.56,121.62a8.31,8.31,0,0,1-3.3-3.11,9.08,9.08,0,0,1,0-9,8.31,8.31,0,0,1,3.3-3.11,10,10,0,0,1,4.74-1.12,10.29,10.29,0,0,1,4.16.82,8,8,0,0,1,3.07,2.35l-3,2.74a5,5,0,0,0-4-2,4.86,4.86,0,0,0-2.43.6,4.16,4.16,0,0,0-1.66,1.69,5.63,5.63,0,0,0,0,5,4.16,4.16,0,0,0,1.66,1.69,4.86,4.86,0,0,0,2.43.6,5,5,0,0,0,4-2l3,2.74a8,8,0,0,1-3.07,2.35,10.29,10.29,0,0,1-4.16.82A10,10,0,0,1,97.56,121.62Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.07,109.37h-5.16V105.6h15v3.77h-5.14v13h-4.75Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4,5.26v5.67L44.34,51.26,12,83.61V31.9l-8-8V97.26H124V91.59L83.66,51.26,116,18.92V70.63l8,8V5.26Zm106.34,84H17.66L50,56.92l14,14,14-14ZM64,59.61,17.66,13.26h92.68Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.998372071f782f57dc0d790cd71e4c02.svg";
export { ForwardRef as ReactComponent };